import VueCookies from 'vue-cookies'

export default () => ({
  get(name, subName) {
    const cookie = document.cookie
    const prefix = name + '='
    let begin = cookie.indexOf('; ' + prefix)
    let end = cookie.length
    if (begin === -1) {
      begin = cookie.indexOf(prefix)
      if (begin !== 0) return null
    } else {
      begin += 2
      end = document.cookie.indexOf(';', begin)
      if (end === -1) {
        end = cookie.length
      }
    }
    const value = unescape(cookie.substring(begin + prefix.length, end))

    if (!subName) {
      return value
    }

    const subCookies = value.split('&')
    for (let i = 0; i < subCookies.length; i++) {
      const pair = subCookies[i].split('=')

      if (pair[0] === subName) {
        let result = pair[1]
        //this is workarounf for the case when tawk writes to our cookie
        if (result && result.indexOf(';') > -1) {
          result = result.split(';')[0]
        }
        return result
      }
    }
    return null
  },
  set(name, value) {
    VueCookies.set(name, value, 60 * 60 * 24 * 30)
  },
  update(name, subName, value) {
    const cookie = this.get(name)
    if (!cookie) {
      return
    }
    const subCookies = cookie.split('&')
    for (let i = 0; i < subCookies.length; i++) {
      const pair = subCookies[i].split('=')

      if (pair[0] !== subName) {
        continue
      }

      subCookies[i] = `${subName}=${value}`
      break
    }
    this.set(name, subCookies.join('&'))
  },
})
